import PersonIcon from "@mui/icons-material/Person";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import OverflowTip from "components/ui/atoms/OverflowTip";

const PeopleHitShort = ({ onClick, hit, ...props }) => {
  return (
    <ListItemButton onClick={() => onClick && onClick(hit.id, hit)} {...props}>
      <ListItemIcon variant="small">
        <PersonIcon />
      </ListItemIcon>
      <ListItemText
        primary={<OverflowTip>{hit.best_name}</OverflowTip>}
        secondary={hit.best_email_address}
      />
    </ListItemButton>
  );
};

export default PeopleHitShort;
